import React, { Component } from 'react';
import { arrayOf, array, bool, func, number, object, shape, string } from 'prop-types';
import DataCutRow from '../DataCutRow/DataCutRow';
import InPlaceIndicator from 'ps-components/LoadingIndicator/InPlaceIndicator/InPlaceIndicator';
import Table from 'ps-components/Table/Table/Table';
import TableBody from 'ps-components/Table/TableBody/TableBody';
import TableHeader from 'ps-components/Table/TableHeader/TableHeader';
import classNames from 'classnames';
import './DataCutsList.scss';

const COLUMNS = ['**', 'Data Cut', 'Currency', 'Priority'];
class DataCutsList extends Component {
  static propTypes = {
    className: string,
    getDataCutPriority: func.isRequired,
    getDataCutName: func.isRequired,
    getDataCutCurrency: func.isRequired,
    getDataCutId: func.isRequired,
    isDataCutSelected: func.isRequired,
    selectDataCut: func,
    dataCuts: array,
    deleteDataCutFromRule: func,
    isSelected: bool,
    selectedRuleConnection: arrayOf(
      shape({
        id: string,
        priority: number,
        dataCut: shape({
          currency: shape({
            code: string
          }),
          id: string,
          name: string,
          survey: shape({
            code: string,
            id: string,
            name: string
          })
        })
      })
    ),
    updateDataCutPriority: func,
    hasStickyColumns: bool
  };

  static defaultProps = {
    selectedRuleConnection: [],
    hasStickyColumns: true
  };

  render() {
    const {
      updateDataCutSelection,
      dataCuts,
      deleteDataCutFromRule,
      selectedRuleConnection,
      updateDataCutPriority,
      getDataCutName,
      getDataCutPriority,
      getDataCutCurrency,
      getDataCutId,
      isDataCutSelected,
      isLoaded,
      isLoading,
      hasStickyColumns
    } = this.props;

    const className = classNames({
      datacuts__table: true,
      [this.props.className]: this.props.className
    });

    return (
      <div className={className}>
        {!isLoading && isLoaded ? (
          <Table hasStickyColumns={hasStickyColumns}>
            <TableHeader
              cellClass="datacuts__table-header-cell"
              columns={COLUMNS}
              headerClass="datacuts__table-header"
              rowClass="datacuts__table-header-row"
            />
            <TableBody className="datacuts__table-body">
              {dataCuts.map((cut, index) => (
                <DataCutRow
                  updateDataCutSelection={updateDataCutSelection}
                  updateDataCutPriority={updateDataCutPriority}
                  dataCut={cut}
                  deleteDataCutFromRule={deleteDataCutFromRule}
                  key={index}
                  selectedRuleConnection={selectedRuleConnection}
                  getDataCutId={getDataCutId}
                  getDataCutName={getDataCutName}
                  getDataCutPriority={getDataCutPriority}
                  getDataCutCurrency={getDataCutCurrency}
                  isDataCutSelected={isDataCutSelected}
                />
              ))}
            </TableBody>
          </Table>
        ) : (
          <InPlaceIndicator />
        )}
      </div>
    );
  }
}

export default DataCutsList;
